import _ from "lodash";
import {
  Component,
} from "react";
import store from "CommonState/store";
import uiconfig from "CommonState/uiconfig";
import {
  Panel, Spinner, Awesome,
} from "CommonComponents/bricks";
import DokumentGruppeWidget from "Components/dokument-gruppe-widget";
import {
  DOKUMENTARTEN,
} from "App/constants";
import DokumentWidget from "Components/dokument-widget";
import {
  Table,
  Button,
  Alert,
} from "react-bootstrap";
import apifetch, {
  getApiHeaders,
} from "CommonCore/apifetch";

@uiconfig
@store("user", "flag_antragstellermodus")
export default class AntragDokumenteSbWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  load = async function(antrag) {
    // Dokumente zum Antrag laden
    if (antrag && antrag.a_id && antrag.a_id != "undefined") {
      const liste = await apifetch(`/api/shkantrag/antrag/dokliste-sb/${ antrag.a_id }`);
      this.setState({ liste: liste.data, downloadError: undefined });
    }
  };

  componentDidMount = () => {
    this.load(this.props.antrag);
  };

  componentDidUpdate = prevProps => {
    if (prevProps.antrag !== this.props.antrag) {
      this.load(this.props.antrag);
    }
  };

  afterUpload = async() => {
    await this.load(this.props.antrag);
  };

  toggleHelp = tag => content => {
    // Hilfebereich togglen
    const data = this.state[tag] || { showHelp: false, helpContent: {} };
    data.helpContent.text = content;
    data.showHelp = !data.showHelp;
    this.setState({ [tag]: data });
  };

  render() {
    let { liste } = this.state;
    const { downloadingZip, downloadError } = this.state;
    const { antrag } = this.props;

    if (!liste) {
      return <Spinner />;
    }

    liste = _.cloneDeep(liste);
    liste.push({ newRow: true,
                 kpf_id: null,
                 kdo_id: DOKUMENTARTEN.ANLAGE_PR,
                 requireName: true,
                 url_upload: "shkantrag/dokument/upload" });

    const vorlagenSB = _.filter(liste, item => item.url_download && !item.url_upload && !item.anhang);
    // TODO filter die  Anlagen-SB
    const anlagenSB = _.groupBy(liste.filter(item => item.anhang), item => item.kpf_id);
    const downloadbareDokumente = _.filter(liste, item => item.url_download);

    const renderRow = (dol, downloadTooltip, prominent) => <DokumentWidget
      key={dol.dol_id}
      downloadTooltip={downloadTooltip}
      downloadProminent={prominent}
      name={dol.dol_bez}
      urlupload={dol.url_upload}
      urldownload={dol.url_download}
      filename={dol.dok_dateiname}
      requireName={dol.requireName}
      afterUpload={this.afterUpload}
      readonly={!dol.newRow}
      params={{ a_id: antrag.a_id, ado_kpfid: dol.kpf_id, kdo_id: DOKUMENTARTEN.ANLAGE_PR, dok_name: dol.dol_kbez, dok_id: dol.dol_dokid, b_id: dol.b_id }}
      urlemptytext={"In Papierform"} />;

    const renderVorlageRow = dol => renderRow(dol, "Vorlage herunterladen", true);

    const renderGroup = array => {
      const dol = array[0];
      return <tr key={dol.dol_id}><td><DokumentGruppeWidget
        key={dol.dol_id}
        name='Zusätzliche elektronische Anlagen'// dol.dol_kbez}
        notation={dol.dol_bez === dol.dol_kbez ? "" : dol.dol_bez}
        items={array}
        afterUpload={this.afterUpload}
        urlupload={dol.url_upload}
        params={{ a_id: antrag.a_id, ado_kpfid: dol.kpf_id, kdo_id: DOKUMENTARTEN.ANLAGE_PR, dok_name: dol.dol_kbez, dok_id: dol.dol_dokid, b_id: dol.b_id }}
      /></td></tr>;
    };

    return <div className='box-panel'>
      <div style={{ textAlign: "right", marginBottom: "8px" }}>
        <Button
          variant='outline-primary'
          size='sm'
          disabled={downloadingZip || _.isEmpty(downloadbareDokumente)}
          onClick={() => this.downloadAll(downloadbareDokumente)}
        >
          <Awesome name='file-archive' />{" "}
          {downloadingZip ? "ZIP wird erstellt..." : "Alle Dokumente herunterladen"}
        </Button>
      </div>
      {downloadError && <Alert variant='danger'>{downloadError}</Alert>}
      <Panel header={<h3>Sachbearbeiter-Dokumente{"\u00a0"}</h3>}>

        {!_.isEmpty(vorlagenSB) &&
          <Table striped>
            <thead><tr><th>Vorlagen</th><th className='td-aktionen'>Aktionen</th></tr></thead>
            <tbody>
              {_.filter(vorlagenSB, item => item.url_download && !item.url_upload).map(dol => renderVorlageRow(dol))}
            </tbody>
          </Table>}

        <table width='100%'>
          <thead>
            <tr>
              <th><h4>Zusätzliche elektronische Anlagen zum Antrag für interne Bearbeitung</h4></th>
            </tr>
          </thead>
          <tbody>
            {_.map(_.isEmpty(anlagenSB) ? { 0: [{ dol_id: 0, ado_kpfid: null, kdo_id: DOKUMENTARTEN.ANLAGE_PR }] } : anlagenSB, renderGroup)}
          </tbody>
        </table>
      </Panel>
    </div>;
  }

  downloadAll = async docs => {
    if (_.isEmpty(docs)) {
      this.setState({ downloadError: "Keine downloadbaren Dokumente vorhanden." });

      return;
    }
    this.setState({ downloadingZip: true, downloadError: undefined });
    try {
      const response = await fetch("/api/shkantrag/dokument/zip", {
        method: "POST",
        headers: { ...getApiHeaders(), "Content-Type": "application/json" },
        body: JSON.stringify({ data: docs }),
      });
      if (!response.ok) {
        this.setState({ downloadError: `Fehler beim ZIP-Download (${ response.status })` });
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Anlagen.zip";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch(err) {
      this.setState({ downloadError: err.message || "Fehler beim ZIP-Download" });
    } finally {
      this.setState({ downloadingZip: false });
    }
  };
}
